import { Customer } from '@commercetools/platform-sdk';
import React, { Dispatch, SetStateAction } from 'react';

export const UserContext = React.createContext<{
  user: Customer | null,
  setUser: Dispatch<SetStateAction<Customer | null>>,
  isUserLoading: boolean,
  setIsUserLoading: Dispatch<SetStateAction<boolean>>
}>({
  user: null,
  setUser: () => null,
  isUserLoading: true,
  setIsUserLoading: () => null
});
